<script>
  import { noop } from 'lodash';
  import { $state as state, currentUser as currentUserProvider, authSession, ngDialog } from 'root/angular-injector-provider';
  import { onMount, onDestroy } from 'svelte';
  import { NAME as SwitchAccountDialog} from '../../dialogs/switch-account/switch-account.ctrl'
  import { NAME as EditRateLoadingInformationDialog } from '../../../entity/rate-loading-information/dialogs/rate-loading-information/rate-loading-information.ctrl'
  import RfpChecklistPdf from 'root/assets/files/ReadyBid Standard RFP Pre Launch Checklist.pdf';
  import defaultImage from 'images/user-image.png';
  import {PAGE_USER_ACCOUNT_MANAGER, PAGE_USER_MESSAGES} from 'root/states';
  import {default as userMessagingStore} from 'root/messaging/user-messaging.store'
  import {
    TRAVEL_AGENCY_TYPE,
    TRAVEL_CONSULTANCY_TYPE
  } from 'vRoot/account-profile/modules/manage-companies/services/manage-company.service';
  import {
    ACCOUNT_ADMIN,
  } from 'vRoot/account-profile/modules/manage-users/services/account-manage-users-list.service';

  const
    MENU_DIVIDER = 'divider',
    MENU_OPTIONS = [
      {
        label: 'Messages',
        icon: 'message',
        action: viewMessages,
        isAvailable: user => user.currentUserAccount
      },

      {
        label: 'Company Profile',
        icon: 'person_pin',
        action: () => go('company-profile'),
        isAvailable: user => user.currentUserAccount && notAgencyAccountManager(user)
      },

      {
        label: 'Users & Permissions',
        icon: 'people',
        action: () => go('rfp-manager-company-profile', {module: 'manageUsers'}),
        isAvailable: user => user.currentUserAccount && notAgencyAccountManager(user)
      },

      {
        label: 'Support Documents',
        icon: 'library_books',
        submenu: [
          {label: 'Pre Launch Checklist', icon: 'fact_check', target: '_blank', href: RfpChecklistPdf},
          {
            label: 'Corporate User Guide',
            icon: 'info_outline',
            target: '_blank',
            href: 'https://www.canva.com/design/DAE87oNozwE/kBuzWfdcGCManM2-wWbiaA/view?utm_content=DAE87oNozwE&utm_campaign=designshare&utm_medium=link2&utm_source=sharebutton'
          },
          {
            label: 'TMC User Guide',
            icon: 'info_outline',
            target: '_blank',
            href: 'https://www.canva.com/design/DAE80F0jNdM/fdlgBtQcNTJhvZ38fogvng/view?utm_content=DAE80F0jNdM&utm_campaign=designshare&utm_medium=link2&utm_source=sharebutton#32'
          },
        ],
        isAvailable: user => user.isBuyer('HOTEL')
      },
      {
        label: 'Rate Loading Information',
        icon: 'account_balance_wallet',
        action: () => showDialog(EditRateLoadingInformationDialog),
        isAvailable: user => user.isBuyer('HOTEL') && notAgencyAccountManager(user),
      },

      {
        label: 'User Profile',
        icon: 'settings_applications',
        action: () => go('user.profile'),
        isAvailable: user => user
      },

      {
        label: 'Hotel Directory',
        icon: 'view_list',
        action: user => go('hotelDirectory', {accountId: user.getAccountId()}),
        isAvailable: user => user.isBuyer('HOTEL') && notAgencyAccountManager(user),
      },

      {
        label: 'Contact / Support',
        icon: 'info',
        href: 'http://readybidnet.freshdesk.com'
      },

      MENU_DIVIDER,

      {
        label: 'Switch Account',
        icon: 'autorenew',
        action: () => showDialog(SwitchAccountDialog),
        isAvailable: user => user.userAccounts > 1,
      },
      {
        label: 'Manage Accounts',
        icon: 'manage_accounts',
        action: () => go(PAGE_USER_ACCOUNT_MANAGER),
        isAvailable: user => user
      },

      MENU_DIVIDER,

      {
        label: 'Sign Out',
        icon: 'power_settings_new',
        action: () => authSession().forget(),
        isAvailable: user => user
      },
    ];

  let
    user = null,
    unwatchUser,
    userPicture = defaultImage,
    menu = [],
    opened = false,
    dropdownIcon;

  onMount(() => { unwatchUser = currentUserProvider().watch(u => user = u) });
  onDestroy(() => { if(unwatchUser) unwatchUser() });

  $: dropdownIcon = opened ? 'keyboard_arrow_up' : 'keyboard_arrow_down';
  $: menu = MENU_OPTIONS.filter(o => o === MENU_DIVIDER || !o.isAvailable || (user && o.isAvailable(user)));

  function go(stateName, params){
    state().go(stateName, params);
  }

  function showDialog(dialogName) {
    ngDialog().show(dialogName).catch( noop )
  }

  function fallbackToDefaultImage(){
    if(userPicture !== defaultImage){
      userPicture = defaultImage;
    }
  }

  function viewMessages() {
    go(PAGE_USER_MESSAGES);
  }

  function notAgencyAccountManager(u){
    if(!u || !u.currentUserAccount) return true;

    const isAgency = [TRAVEL_AGENCY_TYPE, TRAVEL_CONSULTANCY_TYPE].includes(user.currentUserAccount.account.type);
    const isNotAccountAdmin = user.currentUserAccount.role !== ACCOUNT_ADMIN;
    return !(isAgency && isNotAccountAdmin);
  }
</script>

<div class="Component" data-icon-after="{dropdownIcon}" on:click={() => opened = true}>
  <div class="Text">
    <div class="Ellipsis text-right">Hi {user? user.firstName: 'Guest'}</div>
    <div class="Ellipsis text-right">{(user && user.currentUserAccount)? user.currentUserAccount.account.name: ''}</div>
  </div>

  <div class="PictureContainer">
    <img class="Picture" src="{(user && user.profilePicture) || defaultImage}" alt="User" on:error={() => fallbackToDefaultImage()}>
    {#if $userMessagingStore.unread}
      <div class="UnreadMessagesNotification" on:click|stopPropagation={viewMessages}></div>
    {/if}
  </div>
</div>

{#if opened}
  <div class="Backdrop" on:click={() => opened = false}>
    <div class="Menu">
      {#each menu as item, i (i)}
        {#if item === 'divider'}
          <div class="Divider"></div>
        {:else}
          {#if item.href}
            <a class="ActionLink" href="{item.href}" data-icon-before="{item.icon}">{item.label}</a>

          {:else if item.submenu}
            <div class="SubmenuTitle" data-icon-before="{item.icon}">{item.label}</div>
            <div class="Submenu">
              {#each item.submenu as subitem, j (j)}
                {#if subitem === 'divider'}
                  <div class="Divider"></div>
                {:else}
                  {#if subitem.href}
                    <a class="ActionLink" href="{subitem.href}" target="{subitem.target || null}" data-icon-before="{subitem.icon}">{subitem.label}</a>
                  {:else}
                    <div class="ActionButton" data-icon-before="{subitem.icon}" on:click={() => subitem.action(user)}>{subitem.label}</div>
                  {/if}
                {/if}
              {/each}
            </div>

          {:else}
            <div class="ActionButton" data-icon-before="{item.icon}" on:click={() => item.action(user)}>{item.label}</div>
          {/if}
        {/if}
      {/each}
    </div>
  </div>
{/if}


<style lang="stylus">
  @import "../../../styles/styl/font.blocks.styl";

  .Component {
    height: 100%;
    display: flex;
    align-items: center;
    margin-left: 15px;
    font-size : 13px;
    line-height: 1.2;
    color : #FFFFFF;
    cursor: pointer;
  }

  .Text {
    overflow: hidden;
    max-width: 200px;
    margin-right: 10px;
  }

  .PictureContainer {
    flex: 0 0 42px;
    height: 42px;
    position: relative;
  }

  .UnreadMessagesNotification {
    position: absolute;
    top: -5px;
    right: -5px;
    height: 10px;
    width: 10px;
    background: #F15A24;
    border-radius: 20px;
    border: 2px solid #263238;
  }

  .Picture {
    width: 42px;
    height: 42px;
    border: 1px solid #FFFFFF;
    border-radius: 3px;
    background: #E7EBED;
  }

  .Menu {
    position: absolute;
    top: 45px;
    right: 5px;
    min-height: 30px;
    min-width: 100px;
    background: #fff;
    box-shadow: 0 1px 1px 0 rgba(0,0,0,0.1);
  }

  .Divider {
    border: 0;
    display: block;
    height: 1px;
    margin: 0;
    overflow: hidden;
    background-color: rgba(120, 130, 140, 0.13);
    padding: 0;
  }

  .Submenu {
    .ActionButton, .ActionLink, .ActionLink:visited {
      padding-left: 25px;
    }
  }

  .ActionButton, .ActionLink, .ActionLink:visited, .SubmenuTitle {
    text-align: left;
    text-decoration: none;
    padding: 0 10px;
    font-size: 14px;
    height: 36px;
    min-width: 190px;
    box-sizing: border-box;
    color: #263238;

    border-top: 1px solid transparent;
    border-bottom: 1px solid transparent;

    display: flex;

    &:before {
      color: #90A4AE;
      margin-right: 10px;
    }
  }

  .ActionButton, .ActionLink, .ActionLink:visited {
    cursor: pointer;

    &:hover, &:hover:visited {
      background-color: #ECEFF1;
      border-color: #ECEFF1;
      color: #263238;
    }
  }

</style>

